// Import Packages
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// Import Material UI
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import ScheduleIcon from '@material-ui/icons/Schedule';
import AlarmOnIcon from '@material-ui/icons/AlarmOn';
import Grid from "@material-ui/core/Grid";
import StepIcon from '@material-ui/core/StepIcon';
import DoneIcon from '@material-ui/icons/Done';

// Import Pages
import ApplicationService from "../../../../../services/ApplicationService/ApplicationService";
import Search from "../../../../Search/Search";

// Import Helpers
import { capitalizeFirstLetter } from "../../../../../helpers/helper";

// Import CSS
import './Triggers.css';


export default function Triggers({
    selectedAppId,
    triggers,
    setTriggers,
    selectedTriggerId,
    handleSetSelectedTrigger
}) {
    const [searchData, setSearchData] = useState([])
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.TRIGGER-STATIC.TRIGGERS."

    useEffect(() => {
        GetAppTriggerConfigurations().then(r => r);
    }, []);

    async function GetAppTriggerConfigurations() {
        const response = await ApplicationService.getApplicationTriggerConfigurations({ app_id: selectedAppId });
        if (response && response.status && response.data.length) {
            const data = response.data;
            setTriggers(data);
            setSearchData(data);
        }
    }
    //className="triggers-container"
    return (
        <>
            <div className="form-element search-element margin-zero">
                <Search data={triggers} setSearchData={setSearchData} xs={11} sm={11} md={11} lg={11} xl={11}
                    spacing={2}
                    customClasses={['trigger-search']}
                    searchKey={['name']} />
            </div>
            <div className="apps-container" >
                {/*{Object.keys(selectedTrigger).length > 0 && (*/}
                {/*    <>*/}
                {/*        <label className="selected-app-label">{t(label + "SELECTED-TRIGGER").toUpperCase()}</label>*/}
                {/*        <Grid container spacing={3} className="trigger-grid-container">*/}
                {/*            <Grid item xs={12} sm={12} md={6}*/}
                {/*                  className="visible">*/}
                {/*                <div className="trigger-container">*/}
                {/*                    <div className="trigger-item">*/}
                {/*                        <div*/}
                {/*                            className={`trigger-icon trigger-${selectedTrigger.name.replace(' ', '-').toLowerCase()}`}*/}
                {/*                        >*/}
                {/*                            {selectedTrigger.type === 'schedule' && <ScheduleIcon/>}*/}
                {/*                            {selectedTrigger.type === 'realtime' && <AlarmOnIcon/>}*/}
                {/*                        </div>*/}
                {/*                        <span>{t(label + selectedTrigger.name)} ({capitalizeFirstLetter(selectedTrigger.type)})</span>*/}
                {/*                    </div>*/}
                {/*                </div>*/}
                {/*            </Grid>*/}
                {/*        </Grid>*/}
                {/*    </>*/}
                {/*)}*/}
                <Grid container spacing={3} className="trigger-grid-container">
                    {searchData?.length > 0 ? searchData?.map((item, i) => {
                        return (
                            item.trigger_modes?.map((modeItem, mi) => {
                                return (
                                    <Grid item key={mi} xs={12} sm={12} md={12}
                                        className="visible">
                                        <div className="trigger-container">
                                            <div
                                                className={`trigger-item ${selectedTriggerId === modeItem.id ? 'selected' : ''}`}
                                                onClick={() => handleSetSelectedTrigger(item.name, modeItem)}>

                                                <div
                                                    className={`trigger-icon trigger-${item.name.replace(' ', '-').toLowerCase()} ${selectedTriggerId === modeItem.id ? 'selected' : ''}`}
                                                >
                                                    {
                                                        selectedTriggerId !== modeItem.id ? (
                                                            modeItem.type === 'schedule' ? <ScheduleIcon /> : <AlarmOnIcon />
                                                        ) : (
                                                            <DoneIcon alignmentBaseline="central" className="trigger-done-icon" />
                                                        )
                                                    }

                                                </div>
                                                <span>{t(label + item.name)} ({capitalizeFirstLetter(modeItem.type)})</span>
                                            </div>
                                        </div>
                                    </Grid>
                                )
                            })
                        )
                    }) : (
                        <Grid item xs={12} sm={12} md={12}
                            className="visible">
                            <div className="no-data-pane">
                                {t(label + "NO-TRIGGER-FOUND")}
                            </div>
                        </Grid>
                    )}
                </Grid>
            </div>
        </>

    )
}
